module.exports = __webpack_public_path__ + "img/assign-member-icon.062fa14b.svg";